import roundTo from 'round-to';

const floorDecimal = (value, precision = 2, mode = 'down') => roundTo[mode](+value, precision);

export default floorDecimal;
